import { Suspense } from 'react';
import { Helmet } from "react-helmet";
import eero from '../../../images/eero_Amazon_company_logo_WHT.svg';
import hand_phone from '../../../images/hand_phone.svg';
import home from '../../../images/home.svg';
import { useTranslation } from 'react-i18next';
import { getAppOptions, AppType } from '../utils/app-options';

function KilimanjaroApp() {
  const { t } = useTranslation();

  const appOpt = getAppOptions(AppType.Kilimanjaro);
  
  document.title = t("EERO_TITLE");

  return (
    <div className="App">
      <Helmet>
        <meta name="description" content={ t("EERO_META_DESCRIPTION") } />
        <meta name="og:title" content={ t("EERO_META_EERO_OGTITLE") } />
        <meta name="og:description" content={ t("EERO_META_OGDESCRIPTION") } />
      </Helmet>      
      { 
        appOpt.isDesktop 
        ? <div id="desktopView" style={{ visibility : "visible" }}>
            <img src={ eero } className="logo-desktop" alt=""/>
            <h1 className="desktopText">{ t("OPEN_ON_PHONE") }</h1>
            <img src={ hand_phone } className="handPhone" alt=""/>
          </div>
        : <div id="mobileView" style={{ visibility : "visible" }}>
            <img src={ eero } className="logo-mobile" alt=""/>
            <img src={ home } className="home" alt=""/>
            <p className="newTo">{ t("NEW_TO_EERO") }</p>
            <a id="downloadLink" className="buttonHref" href={ appOpt.downloadLink }>
                <div className="button downloadButton">{ t("DOWNLOAD_APP") }</div>
            </a>
            <a id="openLink" className="buttonHref" href={ appOpt.openLink }>
                <div className="button openButton">{ t("OPEN_EERO_APP") }</div>
            </a>
          </div>
      }
    </div>
  );
}

export default function WrappedApp() {
  return (
    <Suspense fallback="...is loading">
      <KilimanjaroApp />
    </Suspense>
  );
}
